import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { collectionActionCreators } from '../../../stores/lis-collection-store';
import { authActionCreators } from '../../../stores/lis-auth-store';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import { CustomOption } from '../../../services/legislation-helper-service';
import { UnsavedNotesModal } from '../../../services/modal-service';

class Collections extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            notes: [],
            expanded: false,
            newNote: {
                Name: '',
                WatchListID: -1,
                isNew: true,
                value: '',
                Description: ''
            },
            menuIsOpen: false,
            fetchingWatchlists: true
        };

        this.toggleExpandNotes = this.toggleExpandNotes.bind(this);
        this.updateNew = this.updateNew.bind(this);
        this.toggleMenuIsOpen = this.toggleMenuIsOpen.bind(this);
        this.handleIsRelated = this.handleIsRelated.bind(this);
        this.manuallyFocusTheNextOne = this.manuallyFocusTheNextOne.bind(this);
        this.selectRef = React.createRef();
    }

    componentDidMount() {
        this.props.actions.getCollections("?SessionID=" + this.props.sessionId)
            .then(() => {
                const legId = this.props.billData.LegislationID;
                let notes = [];
                this.props.collection.collections.forEach(collection => {
                    const legislationInCollection = collection.WatchListLegislation.find(leg => leg.LegislationID === legId);
                    if (legislationInCollection) {
                        notes.push({
                            ...legislationInCollection,
                            Name: collection.Name,
                            Description: collection.Description
                        });
                    }
                });
                this.setState({
                    notes: notes,
                    fetchingWatchlists: false
                });
            }).catch(err => {
                if (err === 'Aborted') {
                    return
                }
            });
    }

    componentDidUpdate(prevProps) {
        if (!this.props.showNoteForm && this.props.showNoteForm !== prevProps.showNoteForm) {
            this.props.actions.getCollections("?SessionID=" + this.props.sessionId)
                .then(() => {
                    const legId = this.props.billData.LegislationID;
                    let notes = [];
                    this.props.collection.collections.forEach(collection => {
                        const legislationInCollection = collection.WatchListLegislation.find(leg => leg.LegislationID === legId);
                        if (legislationInCollection) {
                            notes.push({
                                ...legislationInCollection,
                                Name: collection.Name,
                                Description: collection.Description
                            });
                        }
                    });
                    this.setState({
                        notes: notes
                    });
                })
        }
        else if (prevProps.saving === true && this.props.saving === false) {
            this.props.actions.getCollections("?SessionID=" + this.props.sessionId)
                .then(() => {
                    const legId = this.props.billData.LegislationID;
                    let notes = [];
                    this.props.collection.collections.forEach(collection => {
                        const legislationInCollection = collection.WatchListLegislation.find(leg => leg.LegislationID === legId);
                        if (legislationInCollection) {
                            notes.push({
                                ...legislationInCollection,
                                Name: collection.Name,
                                Description: collection.Description
                            });
                        }
                    });
                    this.setState({
                        notes: notes
                    });
                })
        }
    }

    toggleExpandNotes() {
        this.setState({
            expanded: !this.state.expanded
        })
    }

    updateNew(newValue) {
        this.setState({
            newNote: {
                ...this.state.newNote,
                Name: newValue,
                value: newValue
            }
        })
    }

    toggleMenuIsOpen(value) {
        if (value === undefined) {
            this.setState({ menuIsOpen: !this.state.menuIsOpen });
        } else {
            this.setState({ menuIsOpen: value });
        }
    }

    handleIsRelated(e, direction) {
        const relatedTarget = e.relatedTarget
        if (relatedTarget === null) {
            this.toggleMenuIsOpen(false);
        }
        const isParOfTheSelect = (el) => {
            let parent = el?.parentElement;
            if (parent) {
                if (parent.id === 'sr-watchlist-name-control-bad') {
                    return true;
                } else {
                    return isParOfTheSelect(parent);
                }
            } else {
                return false;
            }
        }
        const shouldClose = isParOfTheSelect(relatedTarget);
        if (shouldClose) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (shouldClose && direction) {

        } else {
            this.toggleMenuIsOpen(shouldClose);
        }
    }

    manuallyFocusTheNextOne(direction) {
        // The id is different depending on where the Modal is ...
        const mainThing = document.getElementById('sr-watchlist-name-control-bad');
        mainThing?.getElementsByTagName('input')[0]?.focus();
        if (direction === 'down') {
            this.selectRef?.current?.select?.focusOption('down');
        } else if (direction === 'up') {
            this.selectRef?.current?.select?.focusOption('up');
        }
    }

    render() {
        const collectionsWithoutThisBill = [{ isNew: true }].concat(this.props.collection.collections.filter(c =>
            !c.WatchListLegislation.find(l => l.LegislationID === this.props.billData.LegislationID)
        ));
        return (<div className='dlas-forms bill-details-watchlist-form' style={{ margin: "0px 0 20px 0" }}>
            {this.state.fetchingWatchlists ? <div className='spinner small-height' /> : this.state.notes && (this.state.notes.length > 0 ?
                <WatchlistsList notes={this.state.notes} saveWatchlist={this.props.handleSaveWatchlist} deleteWatchlists={this.props.handleRemoveWatchlists}
                    saving={this.props.saving} handleSaveWatchlistss={this.props.handleSaveWatchlistss} />
                : <h4 className='bill-details-watchlists-list heading'>No watchlists contain this legislation.</h4>
            )}
            <div className='bill-details-subform'>
                <div className="inner-grid bill-details-watchlist-controls" style={{ marginBottom: "10px" }}>
                    <div style={{ paddingTop: "1px" }}>
                        <label id='add-watchlist-label' htmlFor="sr-watchlist-name-control-bad">
                            <h4>Add legislation to Watchlist(s)</h4>
                        </label>
                        <Select
                            collectionsWithThisBill={this.props.collection.collections.filter(c =>
                                c.WatchListLegislation.find(l => l.LegislationID === this.props.billData.LegislationID))}
                            ref={this.selectRef}
                            id="sr-watchlist-name-control-bad"
                            styles={this.props.selectStyle}
                            options={collectionsWithoutThisBill}
                            getOptionLabel={opt => opt.label || `${opt.Name} ${opt.Description && `- ${opt.Description}`}`}
                            getOptionValue={opt => opt.value || opt.WatchListID}
                            value={this.props.noteWatchlists}
                            onChange={e => { if (Array.isArray(e) && e.find(ee => ee.isNew)) { return null; } this.toggleMenuIsOpen(false); this.props.handleNoteWatchlistChange(e) }}
                            placeholder={"Select or create a new watchlist"}
                            isMulti
                            classNamePrefix='no-width-dropdown-input'
                            components={{ 'Option': CustomOption }}
                            updateNew={this.props.handleNoteWatchlistChange}
                            toggleMenuIsOpen={this.toggleMenuIsOpen}
                            menuIsOpen={this.state.menuIsOpen}
                            onMenuOpen={e => { this.toggleMenuIsOpen(!this.state.menuIsOpen) }}
                            onBlur={e => { this.handleIsRelated(e) }}
                            onKeyDown={e => {
                                // So, arrow keys let you navigate through the options. But we want to be able to auto tab into the new input.
                                // This works for the most part, until you tab into the select initially. Then you need to focus on that specifically.
                                if (e.key === 'Tab' && this.selectRef?.current?.select?.state?.focusedOption?.isNew) {
                                    e.preventDefault();
                                    document.getElementById('add-new')?.focus();
                                } else if (['ArrowDown', 'ArrowUp'].includes(e.key)) {
                                    const current = this.selectRef?.current?.select?.state?.focusedOption?.WatchListID;
                                    const menuOptions = this.selectRef?.current?.select?.state?.menuOptions?.render;
                                    if (menuOptions && menuOptions.length > 1 && current) {
                                        const index = menuOptions.findIndex(o => o.data?.WatchListID === current);
                                        if (index === 1 && e.key === 'ArrowUp') {
                                            this.selectRef?.current?.select?.focusOption('up');
                                            setTimeout(() => document.getElementById('add-new')?.focus())
                                        } else if (index === menuOptions.length - 1 && e.key === 'ArrowDown') {
                                            this.selectRef?.current?.select?.focusOption('down');
                                            setTimeout(() => document.getElementById('add-new')?.focus())
                                        }
                                    } else if (menuOptions && this.selectRef?.current?.select?.state?.focusedOption === undefined && e.key === 'ArrowDown') {
                                        setTimeout(() => document.getElementById('add-new')?.focus())
                                    }
                                }
                            }}
                            manuallyFocusTheNextOne={this.manuallyFocusTheNextOne}
                            handleIsRelated={this.handleIsRelated}
                        />
                    </div>
                    <div className="bill-details-watchlist-input" style={{ display: "grid" }}>
                        <label htmlFor='sr-note-text-control' style={{ margin: "4px 0 0 0" }}>Legislation Note</label>
                        <input
                            id="sr-note-text-control"
                            value={this.props.noteText}
                            onChange={this.props.handleNoteTextChange}
                        />
                        <div />
                    </div>
                    <button style={{ marginTop: "25px", height: "30px" }} disabled={this.props.saving || !this.props.noteWatchlists || this.props.noteWatchlists.length === 0} className="button" type="button" onClick={() => this.props.handleSaveWatchlists()}>Save</button>
                </div>
            </div>
        </div>)
    }
}

export default connect(
    (state) => {
        const { collection, login } = state;
        return {
            collection,
            login
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, authActionCreators, collectionActionCreators), dispatch)
        }
    }
)(Collections)

const WatchlistsList = props => {

    const [showList, toggleShowList] = useState(true);
    const [selectedWatchlists, toggleSelectedWatchlists] = useState([]);
    const [showAllNotes, toggleShowAllNotes] = useState(false);
    const [showNotes, toggleShowNotes] = useState([]);
    const [notes, setNotes] = useState([]);
    const [showUnsavedModal, toggleShowUnsavedModal] = useState(false);

    const [currentlySaving, setCurrentlySaving] = useState([]);

    useEffect(() => {
    }, []);

    useEffect(() => {
        const maintainOpenNotes = (keepSelected) => {
            toggleSelectedWatchlists(props.notes.map(s => false));
            const currentNotes = [...notes].map(n => ({ ...n }));
            const newNotes = [...props.notes].map(n => ({ ...n }));
            const newShowNotes = [];
            const newSelectedWatchlists = [];
            newNotes.forEach(n => {
                const foundNoteIndex = currentNotes.findIndex(cn => cn.WatchListID === n.WatchListID);
                if (currentNotes[foundNoteIndex]) {
                    n.Note = currentNotes[foundNoteIndex].Note
                }
                if (showNotes[foundNoteIndex]) {
                    newShowNotes.push(true);
                } else {
                    newShowNotes.push(false);
                }
                if (keepSelected && selectedWatchlists[foundNoteIndex]) {
                    newSelectedWatchlists.push(true);
                } else {
                    newSelectedWatchlists.push(false);
                }
            });
            toggleSelectedWatchlists(newSelectedWatchlists);
            toggleShowNotes(newShowNotes);
            setNotes(newNotes);
        }
        if (props.notes.length > notes.length) { // New watchlist(s) added. Intial load
            maintainOpenNotes(true);
        } else if (
            props.notes.length < notes.length) {// Watchlist(s) removed
            maintainOpenNotes(false);
        } else {
            const newNotes = notes.map(n => ({ ...n }));
            for (let i = 0; i < props.notes.length; i++) {
                if (props.notes[i].WatchListID === newNotes[i].WatchListID && newNotes[i].ModificationDate !== props.notes[i].ModificationDate) { // don't override the content currently there
                    newNotes[i] = { ...props.notes[i] }
                }
            }
            setNotes(newNotes);
        }
    }, [props.notes]);

    useEffect(() => {
        if (showAllNotes) {
            toggleShowNotes(notes.map(s => true));
        } else {
            toggleShowNotes(notes.map(s => false));
        }
    }, [showAllNotes]);

    const toggleCheckbox = index => {
        const newSelected = [...selectedWatchlists];
        newSelected[index] = !newSelected[index];
        toggleSelectedWatchlists(newSelected);
    }

    const toggleShowNote = index => {
        const newShowNotes = [...showNotes];
        newShowNotes[index] = !newShowNotes[index];
        toggleShowNotes(newShowNotes);
    }

    const updateNote = (value, index) => {
        const newNotes = [...notes].map(n => ({ ...n }));
        newNotes[index].Note = value;
        setNotes(newNotes);
    }

    const handleSaveNote = (i) => {
        if (currentlySaving.length === 0) {
            const callback = () => {
                setCurrentlySaving([]);
                toggleShowNote(i);
            }
            setCurrentlySaving([i]);
            props.saveWatchlist(notes[i], callback);
        }
    }

    const deleteWatchlists = () => {
        if (currentlySaving.length === 0) {
            const watchlistsToDelete = props.notes.filter((_, i) => selectedWatchlists[i]).map(w => w.WatchListID);
            setCurrentlySaving(selectedWatchlists.map((s, i) => s ? i : -1).filter(i => i !== -1));
            props.deleteWatchlists(watchlistsToDelete, setCurrentlySaving([]));
        }
    }

    const clearChange = i => {
        const newNotes = [...notes];
        newNotes[i].Note = props.notes[i].Note;
        setNotes(newNotes);
        toggleShowNote(i);
    }

    const handleToggleAll = () => {
        if (showAllNotes) {
            if (notes.find((note, i) => note.Note !== props.notes[i].Note)) {
                toggleShowUnsavedModal(true);
            } else {
                toggleShowAllNotes(false);
            }
        } else {
            toggleShowAllNotes(true);
        }
    }

    const saveAllNotes = () => {
        const changedNotes = notes.filter((n, i) => n.Note !== props.notes[i].Note);
        const callback = () => {
            setCurrentlySaving([]);
            toggleShowUnsavedModal(false);
            toggleShowAllNotes(false);
        }
        setCurrentlySaving(changedNotes);
        props.handleSaveWatchlistss(changedNotes, callback);
    }

    const ignoreChanges = () => {
        setNotes(props.notes)
        toggleShowUnsavedModal(false);
        toggleShowAllNotes(false);
    }

    const disabled = props.saving || currentlySaving.length > 0;

    return <div className='bill-details-watchlists-list'>
        {showUnsavedModal &&
            <UnsavedNotesModal disable={disabled} closeModal={() => toggleShowUnsavedModal(false)} saveChanges={saveAllNotes} ignoreChanges={ignoreChanges} />
        }
        <div onClick={e => toggleShowList(s => !s)} className='heading'>
            <h4>All Watchlist(s) containing this legislation</h4>
            <button className={showList ? 'arrow-up' : 'arrow-down'}
                title={`${showList ? 'Hide' : 'Show'} watchlists`} aria-label={`${showList ? 'Hide' : 'Show'} watchlists`} />
        </div>
        {
            showList && <div className='bill-details-watchlists-list container'>
                <div className='bill-details-watchlists-list controls'>
                    <div>
                        <button className='button remove-watchlists' disabled={!selectedWatchlists.find(w => w) || disabled} onClick={() => deleteWatchlists()}>Remove from Watchlist(s)</button>
                    </div>
                    <button className='button notes' onClick={() => handleToggleAll()}>{`${showAllNotes ? 'Close' : 'Edit'}`} Notes +/-</button>
                </div>
                <div className='bill-details-watchlists-list watchlist-table'>
                    <div className='bill-details-watchlists-list watchlist-table-header'>
                        <div>Watchlist</div>
                        <div>Legislation Notes</div>
                    </div>
                    {notes.map((note, i) => <div className='bill-details-watchlists-list watchlist-table-row' key={note.WatchListID}>
                        <div className='checkbox-holder'>
                            <input type="checkbox" disabled={disabled} checked={selectedWatchlists[i]} onChange={() => toggleCheckbox(i)} />
                            <Link to={`/bill-search?collection=${note.WatchListID}`}>{note.Name}</Link></div>
                        <div className={'note-entry ' + (showNotes[i] ? 'editing' : '')}>
                            <div className='asterisk-holder'>
                                <button onClick={() => clearChange(i)} className={`icon bubble${!note.Note ? "-hollow" : ''}`} aria-label='edit note' />
                                {!!props.notes[i] && note.Note !== props.notes[i].Note && <div className='red' aria-label='note has been edited' title='note has been edited'>*</div>}
                            </div>
                            {showNotes[i] ?
                                <>
                                    <textarea value={note.Note} rows='1' onChange={e => updateNote(e.target.value, i)} disabled={currentlySaving.includes(i)} />
                                    <button aria-label='save' className='icon save' onClick={() => handleSaveNote(i)} disabled={disabled} />
                                    <button aria-label='cancel' className='icon delete' onClick={() => clearChange(i)} disabled={disabled} />
                                </>
                                :
                                <div className='note-text'>{note.Note}</div>
                            }
                        </div>
                    </div>)}
                </div>
            </div>
        }
    </div >
}
